import { SeparatorDashed } from './components/SeparatorDashed'
import { SeparatorSolid } from './components/SeparatorSolid'

export const Separator = {
  Dashed: SeparatorDashed,
  Solid: SeparatorSolid,
}
